import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
// @ts-ignore
import logo from "../images/logos/edsource-logo_transparent-dark_crop.png";

const Header: React.FC = () => {
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState<null | HTMLElement>(
    null
  );
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const menuItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Map", href: "/map" },
    {
      label: "Reporting",
      href: "https://edsource.org/?post_type=special-project&p=730522",
      target: "_blank",
    },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          mb: 4,
          bgcolor: "#60c09f", // Original background color
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: 3,
          width: "100%",
        }}
      >
        <Container maxWidth={false} disableGutters>
          <Toolbar sx={{ py: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Box
                className="logo"
                sx={{ ml: 0, mr: 3, display: { xs: "none", sm: "block" } }}
              >
                <img
                  src={logo}
                  alt="California School Vaccinations Database"
                  style={{
                    height: "60px",
                    maxWidth: "100%",
                  }}
                />
              </Box>
              <Box
                sx={{
                  borderLeft: "3px solid #024da3", // var(--blue-20) from CSS
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    fontFamily: '"canada-type-gibson", sans-serif',
                    fontSize: "2rem",
                    lineHeight: 1.2,
                    fontWeight: 400,
                    marginBottom: "0.5rem",
                    color: "white",
                  }}
                >
                  California School Vaccinations Database
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="h3"
                  sx={{
                    fontFamily: '"canada-type-gibson", sans-serif',
                    fontSize: "1.2rem",
                    lineHeight: 1,
                    fontWeight: 400,
                    margin: 0,
                    color: "white",
                  }}
                >
                  Find out how many students are vaccinated at your school
                </Typography>
              </Box>
            </Box>
          </Toolbar>
          <Box
            sx={{
              height: "2px",
              backgroundColor: "#024da3", // var(--blue-20) from CSS
              width: "100%",
            }}
          />
          <Box
            className="header-menu"
            sx={{
              display: { xs: "none", sm: "flex" },
              justifyContent: "flex-end",
              padding: "4px 0",
              backgroundColor: "#024da3", // var(--blue-20) from CSS
            }}
          >
            {menuItems.map((item) => (
              <Typography
                key={item.label}
                variant="body1"
                component="a"
                href={item.href}
                target={item.target}
                sx={{
                  color: "white",
                  textDecoration: "none",
                  padding: "0 2rem",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Box>
          {/* Mobile Menu Button */}
          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "flex-end",
              padding: "4px 0",
              backgroundColor: "#024da3",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMobileMenuOpen}
              sx={{ color: "white" }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={mobileMenuAnchor}
              open={Boolean(mobileMenuAnchor)}
              onClose={handleMobileMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#024da3",
                  color: "white",
                },
              }}
            >
              {menuItems.map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={handleMobileMenuClose}
                  component="a"
                  href={item.href}
                  target={item.target}
                  sx={{
                    color: "white",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
                  }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Container>
      </AppBar>
      {/* This toolbar is invisible and serves as a spacer with the same height as the header */}
      <Toolbar sx={{ py: 2, height: "138px", visibility: "hidden" }} />
    </>
  );
};

export default Header;
